import * as React from 'react';

import { CheckboxGroupStateProps } from './CheckboxGroup.types';
import CheckboxGroupContext from './CheckboxGroupContext';

export default function useCheckboxGroup(): CheckboxGroupStateProps | undefined {
  return React.useContext(CheckboxGroupContext);
}
